<script>

export default {
  name: "approver-thumbnails",
  props: {
    approvers: {
      type: Array,
      default: []
    },
    activeIds: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      tooltip: false,
      maxApproversDisplayed: 5
    }
  },
  computed: {
    approverInitials: function () {
      this.approvers.sort((a, b) => {
        if (this.activeIds[a.id] && !this.activeIds[b.id]) {
          return -1;
        } else if (!this.activeIds[a.id] && this.activeIds[b.id]) {
          return 1;
        } else {
          return 0;
        }
      });

      if (this.approvers.length > this.maxApproversDisplayed) {
        const visibleApprovers = this.approvers.slice(0, this.maxApproversDisplayed);
        const remainingApprovers = this.approvers.slice(this.maxApproversDisplayed);
        return { visible: visibleApprovers, remaining: remainingApprovers };
      } else {
        return { visible: this.approvers, remaining: [] };
      }
    }
  },
  methods: {
    selected() {
      this.$emit('selected', this.id);
    },
    remainingApproversTooltip() {
      return this.approverInitials.remaining.map(approver => approver.name).join(', ');
    },
    isActive(id) {
      return !!this.activeIds[id];
    },
    getId(u) {
      return u.approverId || u.userId;
    },
  },
  watch: {
    activeIds: function() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  }
}
</script>

<template>
  <div class="avatar-group d-flex justify-items-start">
    <div v-for="(approver, index) in approverInitials.visible" :key="index"
         :id="'approver-avatar-'+approver.id"
         :title="approver.name"
         :style="{ 'background-color': approver.color, 'color':'white' }"
         :class="{ 'active': isActive(approver.id) }"
         v-b-tooltip.hover.bottom="approver.name"
         class="avatar fs-12 position-relative fw-semibold rounded-circle d-flex align-items-center justify-content-center">
      {{ approver.initials }}
      <div v-if="isActive(approver.id)" class="active-dot toolbar-active-dot rounded-circle bg-success position-absolute start-0 top-0"></div>
    </div>
    <div v-if="approverInitials.remaining.length > 0"
         :title="`+ ${approverInitials.remaining.length} remaining approver(s)`"
         id="remaining-approvers"
         class="avatar fs-12 position-relative fw-semibold rounded-circle d-flex align-items-center justify-content-center">
      +{{ approverInitials.remaining.length }}
      <b-tooltip :target="'remaining-approvers'" triggers="hover" placement="right">
        <div v-for="(approver, index) in approverInitials.remaining" :key="index"
             :id="'approver-avatar-'+approver.id"
             :title="approver.name"
             :style="{ 'background-color': approver.color, 'color':'white' }"
             :class="{ 'active': isActive(approver.id) }"
             v-b-tooltip.hover.bottom="approver.name"
             class="avatar fs-12 position-relative fw-semibold rounded-circle d-flex align-items-center justify-content-center">
          {{ approver.initials }}
          <div v-if="isActive(approver.id)" class="active-dot toolbar-active-dot rounded-circle bg-success position-absolute start-0 top-0"></div>
        </div>
      </b-tooltip>
    </div>
  </div>
</template>

<style scoped>
.avatar {
  /*cursor: pointer !important;*/
}
.avatar.active {
  cursor: grab !important;
}
</style>
